<template>
  <div v-if="data" class="container ugc-container" :class="{ bleedout:data.fullWidth}">
    <AlbumUGC :album-id="data.albumId" :title="data.title ? data.title : '' " :subtitle="data.subtitle ? data.subtitle : '' "></AlbumUGC>
  </div>
</template>

<script>
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import AlbumUGC from '@/components/ugc/AlbumUGC.vue';
import { computed } from 'vue';

export default {
  name: 'Ugc',
  components: { AlbumUGC },
  props: contentfulProps,

  async setup(props, ctx) {
    const { data, init } = useContentful('ugc', props, ctx);
    await init();
    return { data };
  },
};
</script>

<style scoped>
.ugc-container{
  overflow: hidden;
}
</style>
